/**
 * "Download device log file" -- the flow the old tenant device page (SerialNav) used, now admin-only:
 *   1) read the CURRENT metadata of Storage object logs/{serial}.txt (baseline `updated`, or none),
 *   2) send command `uploadlogs` (the player uploads a fresh file),
 *   3) poll every `intervalMs` until the object's `updated` is newer than the baseline (or it appears), up to `timeoutMs`,
 *   4) return its download URL.
 * Pure over injected IO so it is unit-tested with a fake clock.
 *
 * @returns {Promise<{status:'ok',url:string}|{status:'timeout'}>}  rejects (with the original error) if sending the command fails.
 */
export async function fetchDeviceLogFile({ getMeta, getUrl, sendCommand, sleep, now = Date.now, intervalMs = 3000, timeoutMs = 120000, onWaiting = () => {} }) {
  const updatedOf = (meta) => (meta && meta.updated ? new Date(meta.updated).getTime() : null);
  let baseline = null;
  try { baseline = updatedOf(await getMeta()); } catch (_e) { baseline = null; } // no file yet = nothing to compare against
  await sendCommand();
  onWaiting();
  const started = now();
  // eslint-disable-next-line no-constant-condition
  while (true) {
    await sleep(intervalMs);
    try {
      const meta = await getMeta();
      const u = updatedOf(meta);
      if (u !== null && (baseline === null || u > baseline)) {
        return { status: 'ok', url: await getUrl() };
      }
    } catch (_e) { /* not there yet */ }
    if (now() - started >= timeoutMs) return { status: 'timeout' };
  }
}

export const logObjectPath = (serial) => `logs/${serial}.txt`;
